export default [{
    path: '/studentJob',
    name: 'job',
    component: () => import('@/views/studentJob')
},
{
    path: '/studentJob/add',
    component: () => import('@/views/studentJob/add')
},
{
    path: '/studentJob/:id',
    props: (route) => ({
        id:  Number(route.params.id)
    }),
    component: () => import('@/views/studentJob/detail')
},
{
    path: '/studentJob/:id/edit',
    props: (route) => ({
        id:  Number(route.params.id)
    }),
    component: () => import('@/views/studentJob/edit')
},
    {
        path: '/studentJob/:id/copy',
        props: (route) => ({
            id:  Number(route.params.id)
        }),
        component: () => import('@/views/studentJob/copy')
    },
]